export default __webpack_public_path__ + "static/media/iconDownloadCard.303d0952.svg";